import React, {useEffect, useRef, useState} from "react";
import {HeaderDashboard, SideNav} from "../Componat/Header and Side Nav/NavComponant";
import "bootstrap/dist/css/bootstrap.min.css";
import "./form8.css";
import "../css/CustomCss.css";
import {useSelector} from "react-redux";
import {
    AddExtraField,
    ColumnNumber, Form8LastInfo,
    LableColumn, Row1, Row2, Row3, Row4,
    Section1,
    Section2,
    Section3,
    Section4,
    Section5,
    Thead, Tip
} from "../Componat/InputComponant";
import {useNavigate} from "react-router-dom";
import {BaseURL} from "../../../API/API";
import {siteBoundariesBootstrapCSS} from "../css/bootstarpcss";

export default function () {
    const [isOpen, setIsOpen] = useState(true);

    const toggleSidebar = () => setIsOpen(!isOpen);

    return (
        <div className="d-flex flex-column min-vh-100">
            <HeaderDashboard toggleSidebar={()=>{toggleSidebar()}}/>
            <div className="d-flex flex-grow-1">
                <SideNav isOpen={isOpen}/>

                {/* Main Content */}
                <main className={`p-4 w-100 main`}>
                    {/*printForm*/}
                    <Form8AddInformation/>
                </main>
            </div>
        </div>
    )
}

function Form8AddInformation() {

    const handlePrint2 = () => {
        const printWindow = window.open("", "", "height=800,width=1000");

        printWindow.document.write(`
    <html>
      <head>
        <title>Print Table</title>
        <style>
          @media print {
            @page {
              size: legal portrait;
              margin: 2px;
              
            }

            body {
              margin: 0;
              font-family: Arial, sans-serif;
              font-size: smaller;
            }

            .bigTable table {
              width: 100%;
              table-layout: fixed;
              word-wrap: break-word;
            }
            .bigTable textarea{
              width: 80px;            
            }
            .bigTable  input{
              width: 80px;            
            }
            

            th:first-child,
            td:first-child {
              display: none;
            }

            table, th, td {
              border: 1px  solid black;
              border-collapse: collapse;
            }

          }

          body {
            font-family: Arial, sans-serif;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            page-break-inside: auto;
            table-layout: fixed;
            word-wrap: break-word;
          }
          
          table input {
  border: none;
  outline: none;
  background: transparent;
  font-family: inherit;
  width: 100%;
}

        </style>
      </head>
      <body>
        ${document.getElementById("printForm").innerHTML}
      </body>
    </html>
  `);

        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };
    const handlePrint = () => {

        const printWindow = window.open("", "", "height=800,width=1000");
        const documentContent = `
    <html>
      <head>
        <title>Print Table</title>
        <link id="bootstrapLink"
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
          integrity="sha384-ENjdO4Dr2bkBIFxQpeoY9M9BlxOz1KmfN1aKOpu1UHrjjeFm1kMQuawxj7PQ8Z2+"
          crossorigin="anonymous"
        >
        <style>
          ${siteBoundariesBootstrapCSS}
        </style>
      </head>
      <body>
        ${document.getElementById("printForm").innerHTML}
      </body>
    </html>
  `;
        printWindow.document.write(documentContent);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };

    return (
        <div className={"p-1"}>
            <FormHeader/>
            <div className={"card w-100 p-2 mb-3"}>
                <div className={"parent"}>
                    <div className={"child"}>
                        <FormTable  />
                    </div>
                </div>
                <div className="mt-4 mb-3 d-flex justify-content-center">
                    <button onClick={handlePrint} className="btn btn-success m-2">Print</button>
                    {/*<button onClick={back} className="btn btn-danger m-2">Cancel</button>*/}
                </div>

            </div>
        </div>
    );
}


function FormHeader() {
    return (
        <div className={"card w-100 p-2 mb-3"}>
            <span className={"text-secondary"}>Edit Form 8 (नमुना ८)</span>
            <span className={"text-success"}>
                  To print this page set "Legal size" page and printing scale is (90%). in print setup Dialogbox.
              </span>
        </div>
    );
}

function FormTable() {
    const form8data = useSelector((state) => state.form8?.form8data);
    // ====================section 1===============
    const [panchayatAndDistrictNumber,setPanchayatAndDistrictNumber]=useState(form8data.Panchayat_No);
// ====================section 2===============
    const [grampanchayat, setGrampanchayat] = useState(form8data.GramPanchayat_Name1);
    const [panS, setPanS] = useState(form8data.PanchayatSamiti_Name);
    // ====================section 3===============
    const [year1, setYear1] = useState(form8data.year1);
    const [year2, setYear2] = useState(form8data.year2);
    // ====================section 4===============
    const [gramPanchayat, setGramPanchayat] = useState(form8data.GramPanchayat_Name2);
    //=====================section 5==============
    const [gramPanchayat1, setGramPanchayat1] = useState(form8data.GramPanchayat_Name3);
    const [oldPropertyNo, setOldPropertyNo] = useState(form8data.Old_Property_No);
    const [taluka, setTaluka] = useState(form8data.Taluka_Name);
    const [district, setDistrict] = useState(form8data.Zilla_Name);
    const [serialNo, setSerialNo] = useState(form8data.Sr_No);
    const [propertyNo, setPropertyNo] = useState(form8data.Property_No);
    const [ownerName, setOwnerName] = useState(form8data.Owner_Name);
    const [wifeName, setWifeName] = useState(form8data.Wife_Name);
    const [occupantName, setOccupantName] = useState(form8data.Occupant_Name);

    //================Big Table=========
    //=============Lable==============
    const [extendRow,setExtendRow]=useState(JSON.parse( form8data.ExtendData));
    //=============Row1=================
    //==============Col6===========
    const initialSiteValues = {
        East: "",
        West: "",
        North: "",
        South: "",
    };
    const [sites, setSites] = useState(initialSiteValues);


    const [total_area_east_west1, setTotal_area_east_west1] = useState(JSON.parse(form8data.Col8).total_area_east_west1);
    const [total_area_north_south1, setTotal_area_north_south1] = useState(JSON.parse(form8data.Col8).total_area_north_south1);
    const [total_area_east_west2, setTotal_area_east_west2] = useState(JSON.parse(form8data.Col8).total_area_east_west2);
    const [total_area_north_south2, setTotal_area_north_south2] = useState(JSON.parse(form8data.Col8).total_area_north_south2);
    const [remain_area, setRemain_area] = useState(JSON.parse(form8data.Col11).remain_area);
    const [remain_area1, setRemain_area1] = useState(JSON.parse(form8data.Col11).remain_area1);

    //=========col-7====
    const [citySurveyNo,setCitySurveyNo]=useState(form8data.Col7);

    const [openSpaceSq_Ft,setOpenSpaceSq_Ft]=useState(0);
    const [openSpaceSq_Mt,setOpenSpaceSq_Mt]=useState(0);


    const [bhumikar,setBhumikar]=useState(0);
    const [box,setBox]=useState({
        box3:JSON.parse(form8data.Box).box3,
        box4:JSON.parse(form8data.Box).box4,
        box5:JSON.parse(form8data.Box).box5,
        box6:JSON.parse(form8data.Box).box6,
    });

    //==========col-20========
    const [col20,setCol20]=useState(parseInt(form8data.Col20));
    //==========col-21========
    const [col21,setCol21]=useState(parseInt(form8data.Col21));
    //============Row2======
    const [total_sq_ft, setTotal_sq_ft] = useState(JSON.parse(form8data.Col8).total_sq_ft);
    const [total_sq_mt, setTotal_sq_mt] = useState(JSON.parse(form8data.Col8).total_sq_mt);
    const [grandTotal,setGrandTotal]=useState(form8data.Total_groung);


    //=========Tip======
    const [tip,setTip]=useState(form8data.Tip);
    const [adharcard,setAdharcard]=useState(form8data.Adhar);
    const [mobile,setMobile]=useState(form8data.Mobie);


    const [count,setCount]=useState(JSON.parse(form8data.ExtendData).length-1);
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let year = 1950; year <= currentYear; year++) {
        years.push(year);
    }

    useEffect(() => {
        let parsedSites = initialSiteValues;

        try {
            const parsed = JSON.parse(form8data?.Col6 || '{}');

            if (
                typeof parsed === 'object' &&
                parsed !== null &&
                ['East', 'West', 'North', 'South'].every(dir => dir in parsed)
            ) {
                parsedSites = {
                    East: parsed.East || "",
                    West: parsed.West || "",
                    North: parsed.North || "",
                    South: parsed.South || "",
                };
            }
        } catch (error) {
            console.warn("Failed to parse form8data.Col6", error);
        }

        setSites(parsedSites);
    }, []);



    function Add() {
        const newRow = {
            Col9: "झोपडी किंवा मातीचे घर",
            Col10: { East_West: 0, North_South: 0 },
            Col13_Col14:{Building:0,Land:0},
            Col15: 0,
            Col16: { Building: 0, Land: 0 },
            Col17: "निवासी",
            Col18: { Building: 0, Land: 0 },
            Year: "",
            Sq_Ft: "",
            Sq_Mt: "",
            Col19_Gruhakar: 0
        };
        setExtendRow(prev => [...prev, newRow]);
        setCount(prev => prev + 1);
    }

    function Remove() {
        if(count!=0){
            setExtendRow(prev => prev.slice(0, -1));
            setCount(prev => prev - 1);
        }
    }

    //=========Row1====Function======
    const handleSiteChange = (key,value) => {
        updateSite(key,value);
    };
    const updateSite = (key, value) => {
        setSites(prev => ({
            ...prev,
            [key]: value
        }));
    };
    const handleAreaChange = (key, e) => {
        const val = e;
        if (key === 'ew1') setTotal_area_east_west1(val);
        else if (key === 'ns1') setTotal_area_north_south1(val);
        else if (key === 'ew2') setTotal_area_east_west2(val);
        else if (key === 'ns2') setTotal_area_north_south2(val);
    };
    useEffect(()=>{
        const res = (total_area_east_west1 * total_area_north_south1)+(total_area_east_west2 * total_area_north_south2);
        setTotal_sq_ft(res);//total_sq_ft
        setTotal_sq_mt(parseFloat(res*0.093));
        setRemain_area(parseFloat(res*0.093));
    },[total_area_east_west1,total_area_north_south1,total_area_east_west2,total_area_north_south2])
    const handleRemainChange = (key, e) => {
        const val = e;
        if (key === 'remain1') setRemain_area(val);
        else if (key === 'remain2') setRemain_area1(val);
    };

    //==============Add Extra====
    const onChangeAddExtra=(data,index)=>{
        updateExtendRowValue(index,data.key,data.data);
        if(data.key==="Col10"){
            //calBuildArea
            let  _build_area_east_west=data.data.East_West;
            let  _build_area_north_south=data.data.North_South;
            let res = _build_area_east_west*_build_area_north_south;
            updateExtendRowValue(index,"Sq_Ft",res);
            updateExtendRowValue(index,"Sq_Mt",(res*0.093).toFixed(3));
        }else
        if(data.key==="Col13Col14"||data.key==="Col15"||data.key==="Col18"){
            //calHomeTax
            let resTotal=0;
            let total_build_area_sq_mt=extendRow[index].Sq_Mt;
            let redireknar_build=extendRow[index].Col13_Col14.Building;
            let ghasara=extendRow[index].Col15;
            let ghasara1=ghasara/100;
            //Col16.Building never use as input
            let tax_price_build=extendRow[index].Col18.Building;

            //=======set value===========
            let res = total_build_area_sq_mt*redireknar_build*ghasara1;
            let rest1 = res*tax_price_build;
            updateNestedExtendRowValue(index, "Col16", "Building", rest1);
            //========================
            let thausand = 1000;
            let res2 = rest1/thausand;
            resTotal= resTotal+res2;
            updateExtendRowValue(index,"Col19_Gruhakar",res2);
            setGrandTotal(resTotal.toFixed(3));

            //========calLandTax=======
            {
                let total_remain_sq_mt=  openSpaceSq_Mt; //#780000  col=11 Row=3 khali jaga
                let redireknar_land =  extendRow[0].Col13_Col14.Land; //col=14 Row=1 Jamin

                let tax_price_land=extendRow[0].Col18.Land;
                let res = total_remain_sq_mt*redireknar_land*tax_price_land;
                updateNestedExtendRowValue(index, "Col16", "Land", res);
                let res1 = res/1000;
                setBhumikar(res1);
            }

        }
    }
    const updateExtendRowValue = (index, key, value) => {
        setExtendRow(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                [key]: value
            };
            return updated;
        });
    }
    const updateNestedExtendRowValue = (index, parentKey, childKey, value) => {
        setExtendRow(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                [parentKey]: {
                    ...updated[index][parentKey],
                    [childKey]: value
                }
            };
            return updated;
        });
    };
    useEffect(()=>{
        setOpenSpaceSq_Ft(total_sq_ft-extendRow[0].Sq_Ft);
        setOpenSpaceSq_Mt(total_sq_mt-extendRow[0].Sq_Mt);
    },[extendRow]);
    //============onChange Box=========
    const onChangeBox=(key,value)=> {
        updateBoxValue(key,value);
    }
    const updateBoxValue = (key, value) => {
        setBox(prev => ({
            ...prev,
            [key]: value
        }));
    };
    useEffect(()=>{
        let _home_tax_grand_total=parseFloat(grandTotal);
        let _bhumikar=parseFloat(bhumikar);
        let _vijkar=parseFloat(box.box3);
        let _arogyakar=parseFloat(box.box4);

        let _sa_panikar=parseFloat(box.box5);
        let _vi_panikar=parseFloat(box.box6);

        let _ress = _home_tax_grand_total+_bhumikar+_vijkar+_arogyakar+_sa_panikar+_vi_panikar;
        setCol20(_ress);
    },[box]);

    return (
        <div>
            <div id={"printForm"} className={"overflow-size "}>
                {/*============Section1=====*/}
                <Section1
                    value={panchayatAndDistrictNumber}
                    onChange={(e) => setPanchayatAndDistrictNumber(e.target.value)}/>
                {/*============Section2=====*/}
                <Section2
                    grampanchayat={grampanchayat}
                    setGrampanchayat={setGrampanchayat}
                    panS={panS}
                    setPanS={setPanS}
                />
                {/*============Section3=====*/}
                <Section3
                    year1={year1}
                    setYear1={setYear1}
                    year2={year2}
                    setYear2={setYear2}
                />
                {/*============Section4=====*/}
                <Section4
                    gramPanchayat={gramPanchayat}
                    setGramPanchayat={setGramPanchayat}
                />
                {/*============Section5=====*/}
                <Section5
                    gramPanchayat={gramPanchayat1} setGramPanchayat={setGramPanchayat1}
                    oldPropertyNo={oldPropertyNo} setOldPropertyNo={setOldPropertyNo}
                    taluka={taluka} setTaluka={setTaluka}
                    district={district} setDistrict={setDistrict}
                    serialNo={serialNo} setSerialNo={setSerialNo}
                    propertyNo={propertyNo} setPropertyNo={setPropertyNo}
                    ownerName={ownerName} setOwnerName={setOwnerName}
                    wifeName={wifeName} setWifeName={setWifeName}
                    occupantName={occupantName} setOccupantName={setOccupantName}
                />


                {/*==============5=Big==========*/}
                <div className={"mt-3 bigTable"}>
                    <table className="custom-table">
                        <Thead/>
                        <tbody>
                        {/*---------------Number------------*/}
                        <ColumnNumber/>
                        {/*-------------------Label---------*/}
                        <LableColumn Add={Add} Remove={Remove}  count={count} setCount={setCount} />
                        {/*----------------Row1---------------*/}
                        <Row1
                            sites={sites}
                            handleSiteChange={handleSiteChange}
                            handleAreaChange={handleAreaChange}
                            handleRemainChange={handleRemainChange}
                            total_area_east_west1={total_area_east_west1}
                            total_area_north_south1={total_area_north_south1}
                            total_area_east_west2={total_area_east_west2}
                            total_area_north_south2={total_area_north_south2}
                            remain_area={remain_area}
                            remain_area1={remain_area1}
                            valueCol7={citySurveyNo}
                            onChangeCol7={(value)=>setCitySurveyNo(value)}
                            years={years}
                            onChangeAddExtra={onChangeAddExtra}
                            extendRow={extendRow[0]}
                            bhumikar={bhumikar}
                            onChangeBox={onChangeBox}
                            index={0}
                            box={box}
                            col20={col20}
                            col21={col21}
                            setCol21={setCol21}
                            isPrint={true}
                        />

                        {/*----------------Row2---------------*/}
                        <Row2 total_sq_ft={total_sq_ft}
                              openSpaceSq_Ft={openSpaceSq_Ft}
                              grandTotal={grandTotal}
                              extendRow={extendRow[0]}
                        />

                        {/*----------------Row3---------------*/}
                        <Row3 total_sq_mt={total_sq_mt}
                              openSpaceSq_Mt={openSpaceSq_Mt}
                              extendRow={extendRow[0]}
                        />
                        {/*----------------Row4---------------*/}
                        <Row4/>
                        {/*=========================Extra Data==========================================================================================================================================================*/}
                        {Array.from({ length: count }, (_, index) => (
                            // <AddExtra key={`item${index}`}/>
                            <AddExtraField key={`item${index}`} index={index+1}
                                           extendRow={extendRow[index+1]}
                                           onChangeAddExtra={onChangeAddExtra}  />
                        ))}

                        {/*=========================Extra Data================================*/}
                        {/*----------------Tip---------------*/}
                        <Tip tip={tip} setTip={setTip} adharcard={adharcard} setAdharcard={setAdharcard} mobile={mobile} setMobile={setMobile}/>
                        </tbody>
                    </table>
                </div>
                {/*==============6===========*/}
                <Form8LastInfo/>


            </div>
        </div>
    );
}
